"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.BusType = void 0;
var events_1 = require("events");
var ExtAdapter_1 = require("../modules/ExtAdapter");
var ExtFrame_1 = __importDefault(require("./ExtFrame"));
var ExtLogger_1 = __importDefault(require("../modules/ExtLogger"));
var ExtFrameMessage_1 = require("./ExtFrameMessage");
var url_parse_1 = __importDefault(require("url-parse"));
var md5_1 = __importDefault(require("md5"));
var ext_1 = require("../util/ext");
var ExtError_1 = require("../modules/ExtError");
var ExtEndpointModuleBus_1 = __importDefault(require("./ExtEndpointModuleBus"));
var ExtUserAuth_1 = __importDefault(require("./ExtUserAuth"));
var tracking_1 = require("../util/tracking");
var BusType;
(function (BusType) {
    BusType["LIVE_EVENT"] = "liveEvent";
    BusType["LOCAL_MESSAGE"] = "localMessage";
})(BusType = exports.BusType || (exports.BusType = {}));
/**
 * 小程序endpoint模块，可以用其同名的实例方法处理frameMessage的请求
 */
var ExtEndpointModule = /** @class */ (function (_super) {
    __extends(ExtEndpointModule, _super);
    function ExtEndpointModule(extMain, extEndpoint, adapter) {
        var _this = _super.call(this) || this;
        _this.extMain = extMain;
        _this.extEndpoint = extEndpoint;
        _this.logger = ExtLogger_1["default"].getExtSysLogger({
            extType: extEndpoint.extType,
            extUuid: extMain.extUuid,
            log: function (logContent) { return adapter.log(logContent); }
        });
        _this.extFrame = new ExtFrame_1["default"](extMain, extEndpoint, adapter);
        _this.bus = new ExtEndpointModuleBus_1["default"]();
        _this.hbTimer = 0;
        _this.loaded = false;
        _this.userAuth = ExtUserAuth_1["default"].getInstance(_this.logger, _this.extMain);
        return _this;
    }
    /**
     * 获取实例
     * @param extMain 小程序主体信息
     * @param extEndpoint 小程序endpoint信息
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.getInstance = function (extMain, extEndpoint, adapter) {
        var Ctor = this;
        // @ts-ignore
        var instance = new Ctor(extMain, extEndpoint, adapter);
        return instance.init(adapter);
    };
    /**
     * 获取小程序endpoint模块的唯一id
     */
    ExtEndpointModule.prototype.getKey = function () {
        return this.extMain.extUuid + "_" + this.extEndpoint.extType;
    };
    /**
     * 初始化一个小程序endpoint模块
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.init = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var showFlag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('初始化一个小程序endpoint模块');
                        return [4 /*yield*/, this.initEndpoint(adapter)
                            // tracking
                        ];
                    case 1:
                        _a.sent();
                        // tracking
                        if (this.extEndpoint.extType === 'web_video_com' && this.extEndpoint.typeAuthority.extTypeIconInfo) {
                            showFlag = this.extEndpoint.typeAuthority.extTypeIconInfo.showFlag;
                            if (showFlag & Number(ext_1.ShowFlag.ENTRANCE)) {
                                tracking_1.extMark('show_entrance_succ', this.extMain.extUuid, this.extEndpoint.extType);
                            }
                            else {
                                tracking_1.extMark('show_entrance_fail', this.extMain.extUuid, this.extEndpoint.extType);
                            }
                        }
                        return [4 /*yield*/, this.statusNotice(this.extEndpoint.typeAuthority.extTypeIconInfo, adapter)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(this)];
                }
            });
        });
    };
    /**
     * 上报小程序曝光埋点
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.sys_pageshow_ext_list = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, adapter.sys_pageshow_ext_list(this.extMain, this.extEndpoint)];
            });
        });
    };
    /**
     * 上报小程序交互埋点
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.sys_startup_ext_interactive = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, adapter.sys_startup_ext_interactive(this.extMain, this.extEndpoint)];
            });
        });
    };
    /**
     * 上报小程序心跳埋点
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.sys_ext_heartbeat_ext_interactive = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, adapter.sys_ext_heartbeat_ext_interactive(this.extMain, this.extEndpoint, this.sessionId)];
            });
        });
    };
    /**
     * 上报小程序浮窗显示埋点
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.sys_pageshow_ext_panelshow = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, adapter.sys_pageshow_ext_panelshow(this.extMain, this.extEndpoint, this.sessionId)];
            });
        });
    };
    /**
     * 开始心跳
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.startup = function (adapter) {
        var _this = this;
        this.sessionId = md5_1["default"](this.getKey() + new Date().valueOf());
        this.logger.debug('心跳开始', { sessionId: this.sessionId });
        clearInterval(this.hbTimer);
        this.hbTimer = setInterval(function () {
            _this.sys_ext_heartbeat_ext_interactive(adapter);
        }, ext_1.HB_INTERVAL);
    };
    /**
     * 停止心跳
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.pause = function (adapter) {
        this.logger.debug('心跳结束', { sessionId: this.sessionId });
        clearInterval(this.hbTimer);
        this.hbTimer = 0;
    };
    /**
     * 触发Load生命周期
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postLifeLoad = function (adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.LIFE_LOAD, { type: String(ext_1.PostMessageTopic.LIFE_LOAD) }, adapter);
    };
    /**
     * 触发EnterForeGround生命周期
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postLifeEnterForeground = function (adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.LIFE_ENTER_FOREGROUND, { type: String(ext_1.PostMessageTopic.LIFE_ENTER_FOREGROUND) }, adapter);
    };
    /**
     * 触发Appear生命周期
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postLifeAppear = function (adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.LIFE_APPEAR, { type: String(ext_1.PostMessageTopic.LIFE_APPEAR) }, adapter);
    };
    /**
     * 触发LeaveForeground生命周期
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postLifeLeaveForeground = function (adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.LIFE_LEAVE_FOREGROUND, { type: String(ext_1.PostMessageTopic.LIFE_LEAVE_FOREGROUND) }, adapter);
    };
    /**
     * 触发Disapper生命周期
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postLifeDisappear = function (adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.LIFE_DISAPPEAR, { type: String(ext_1.PostMessageTopic.LIFE_DISAPPEAR) }, adapter);
    };
    /**
     * 显示
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.showPanel = function (adapter) {
        this.startup(adapter);
        this.showEndpointPanel(adapter);
    };
    /**
     * 隐藏
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.hidePanel = function (adapter) {
        this.pause(adapter);
        this.hideEndpointPanel(adapter);
    };
    /**
     * 显示入口
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.showExtEntrance = function (adapter) {
        this.showEndpointEntrance(adapter);
    };
    /**
     * 隐藏入口
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.hideExtEntrance = function (adapter) {
        this.hideEndpointEntrance(adapter);
    };
    /**
     * 弹出使用开发版确认弹窗
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.showUsingUnpublishConfirm = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModalContainer(adapter)];
                    case 1:
                        container = _a.sent();
                        return [2 /*return*/, adapter.showUnpublishedConfirmModal(this.extMain, this.extEndpoint, container)];
                }
            });
        });
    };
    /**
     * 初始化小程序frame
     * @param adapter 小程序适配器
     * @param query 【可选】查询串
     */
    ExtEndpointModule.prototype.initBusiFrame = function (adapter, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.extFrame.busiFrameLoaded) return [3 /*break*/, 1];
                        this.logger.debug('小程序iframe已经初始化了哦');
                        this.emit('initBusiFrameAfterLoaded');
                        return [3 /*break*/, 4];
                    case 1:
                        this.logger.debug('初始化小程序iframe', { extUuid: this.extMain.extUuid, extType: this.extEndpoint.extType });
                        if (!this.busiFrameIniting) return [3 /*break*/, 2];
                        this.logger.warn('小程序iframe初始化中，请稍等');
                        return [3 /*break*/, 4];
                    case 2:
                        this.busiFrameIniting = true;
                        return [4 /*yield*/, this.userAuth.initAuth(adapter, this.extEndpoint)];
                    case 3:
                        _a.sent();
                        tracking_1.extMark('exec_start', this.extMain.extUuid, this.extEndpoint.extType);
                        this.extFrame.postMessage(ExtFrameMessage_1.Topic.SUP_INIT, JSON.parse(JSON.stringify({
                            hostOrigin: window.location.origin,
                            extInfo: this.getSupInitExtInfo(),
                            query: query
                        })), adapter);
                        tracking_1.extMark('exec_succ', this.extMain.extUuid, this.extEndpoint.extType);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取小程序host
     */
    ExtEndpointModule.prototype.getDomain = function () {
        if (ext_1.isDev(this.extMain)) {
            var url = new url_parse_1["default"](this.extMain.extVersionDetail.extTestUri);
            return url.protocol + "//" + url.host;
        }
        else {
            return this.extMain.extFrontDomain;
        }
    };
    /**
     * 获取小程序path
     */
    ExtEndpointModule.prototype.getViewerPath = function () {
        if (ext_1.isDev(this.extMain)) {
            var url = new url_parse_1["default"](this.extMain.extVersionDetail.extTestUri);
            return "" + url.pathname + this.extEndpoint.extViewerPath;
        }
        else {
            return this.extEndpoint.extViewerPath;
        }
    };
    /**
     * 获取中间层iframe初始化小程序信息
     */
    ExtEndpointModule.prototype.getSupInitExtInfo = function () {
        return {
            extHostLevel: this.extMain.extAppCspPolicy.hostLevel,
            extUuid: this.extMain.extUuid,
            extVersion: this.extMain.extVersion,
            extVersionId: this.extMain.extVersionDetail.extVersionId,
            extVersionType: this.extMain.extVersionDetail.extVersionType,
            extName: this.extMain.extName,
            extIcon: this.extMain.extVersionDetail.extIcon,
            extDomain: this.getDomain(),
            extAuthorAppId: this.extMain.authorAppId,
            extAuthorName: this.extMain.extVersionDetail.extAuthorName,
            extEndpointId: this.extEndpoint.extEndpointId,
            extType: this.extEndpoint.extType,
            extViewerPath: this.getViewerPath(),
            extAnchorViewerPath: this.extEndpoint.extAnchorViewerPath,
            extConfig: this.extEndpoint.typeAuthority,
            extApiAuth: this.extEndpoint.typeAuthority.apiAuthority.value,
            extLogo: this.extMain.extVersionDetail.extLogo
        };
    };
    /**
     * 处理小程序业务消息
     * @param msg 业务消息
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.handleExtFrameMessage = function (msg, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var provider, _a, _b, _c, err_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!msg.funcName) return [3 /*break*/, 6];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, adapter.extApiAuth.auth(this.extEndpoint, msg.funcName, msg.message)];
                    case 2:
                        _d.sent();
                        _b = (_a = adapter).getFunctionalProvider;
                        _c = [this.extMain, this.extEndpoint];
                        return [4 /*yield*/, this.getModalContainer(adapter)];
                    case 3:
                        provider = _b.apply(_a, _c.concat([_d.sent()]));
                        if (msg.funcName in this) {
                            this.logger.debug('使用ExtEndpointModule处理', { funcName: msg.funcName });
                            // @ts-ignore
                            return [2 /*return*/, this[msg.funcName](msg.message, adapter)];
                        }
                        else if (msg.funcName in provider) {
                            this.logger.debug('使用ExtFunctionalProvider处理', { funcName: msg.funcName });
                            // @ts-ignore
                            return [2 /*return*/, provider[msg.funcName](msg.message, adapter)];
                        }
                        else {
                            this.logger.warn('无法处理', { funcName: msg.funcName });
                            return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError("\u5C0F\u7A0B\u5E8F\u4E0D\u652F\u6301\u63A5\u53E3" + msg.funcName + "\u8C03\u7528\uFF0C\u8BF7\u67E5\u770B\u6587\u6863\u786E\u8BA4\u63A5\u53E3\u7684\u9002\u7528\u5E73\u53F0\u6216\u8005\u517C\u5BB9\u60C5\u51B5"))];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _d.sent();
                        this.logger.warn("\u8C03\u7528" + msg.funcName + "\u5931\u8D25", { err: err_1.message });
                        return [2 /*return*/, Promise.reject(err_1)];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.logger.warn('无法处理请求', { topic: msg.topic });
                        return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError("\u65E0\u6CD5\u5904\u7406\u8BF7\u6C42" + msg.topic))];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 触发小程序业务消息
     * @param event 消息名
     * @param content 消息内容
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postObserverMessage = function (event, content, adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.OBSERVER, { event: event, content: content }, adapter);
    };
    /**
     * 触发小程序宿主消息
     * @param event 消息名
     * @param content 消息内容
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.postContextMessage = function (event, content, adapter) {
        return this.extFrame.postMessageToBusiFrame(ext_1.PostMessageTopic.CONTEXT, { event: event, content: content }, adapter);
    };
    ExtEndpointModule.prototype.handleSupReady = function (adapter, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!ext_1.isPublished(this.extMain)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.showUsingUnpublishConfirm(adapter)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initBusiFrame(adapter, query)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.initBusiFrame(adapter, query)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 处理小程序iframe消息
     * @param msg 小程序frame消息
     * @param adapter 小程序适配器
     */
    ExtEndpointModule.prototype.handleFrameMessage = function (msg, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, _a, isReady, rsp, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.debug('处理frame message', { topic: msg.topic, extUuid: this.extMain.extUuid, extType: this.extEndpoint.extType });
                        resp = new ExtAdapter_1.HandleFrameMessageResp();
                        _a = msg.topic;
                        switch (_a) {
                            case String(ExtFrameMessage_1.Topic.SUP_READY): return [3 /*break*/, 1];
                            case String(ExtFrameMessage_1.Topic.FRAME_LAUNCH): return [3 /*break*/, 4];
                            case String(ExtFrameMessage_1.Topic.FRAME_ERR): return [3 /*break*/, 5];
                            case String(ExtFrameMessage_1.Topic.FRAME_LOAD): return [3 /*break*/, 6];
                            case String(ExtFrameMessage_1.Topic.SUP_ERROR): return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 9];
                    case 1:
                        tracking_1.extMark('load_supframe_succ', this.extMain.extUuid, this.extEndpoint.extType);
                        this.extFrame.ready();
                        return [4 /*yield*/, this.postInit(adapter)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.handleSupReady(adapter, this.query)];
                    case 3:
                        _b.sent();
                        resp.handleType = ExtAdapter_1.HandleType.SILENT;
                        return [3 /*break*/, 13];
                    case 4:
                        tracking_1.extMark('load_busiframe_start', this.extMain.extUuid, this.extEndpoint.extType);
                        return [3 /*break*/, 13];
                    case 5:
                        tracking_1.extMark('load_busiframe_fail', this.extMain.extUuid, this.extEndpoint.extType);
                        return [3 /*break*/, 13];
                    case 6:
                        tracking_1.extMark('load_busiframe_succ', this.extMain.extUuid, this.extEndpoint.extType);
                        this.extFrame.busiReady();
                        this.busiFrameIniting = false;
                        return [4 /*yield*/, this.ready(adapter)];
                    case 7:
                        isReady = _b.sent();
                        if (isReady) {
                            this.postLifeLoad(adapter);
                        }
                        resp.handleType = ExtAdapter_1.HandleType.SILENT;
                        return [3 /*break*/, 13];
                    case 8:
                        tracking_1.extMark('load_supframe_fail', this.extMain.extUuid, this.extEndpoint.extType);
                        this.showSupError(msg.originData.message, adapter);
                        resp.handleType = ExtAdapter_1.HandleType.SILENT;
                        return [3 /*break*/, 13];
                    case 9:
                        // TODO
                        this.extFrame.busiReady();
                        this.busiFrameIniting = false;
                        resp.handleType = ExtAdapter_1.HandleType.RESPONSABLE;
                        _b.label = 10;
                    case 10:
                        _b.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, this.handleExtFrameMessage(msg, adapter)];
                    case 11:
                        rsp = _b.sent();
                        resp.rsp = rsp;
                        return [3 /*break*/, 13];
                    case 12:
                        err_2 = _b.sent();
                        resp.err = err_2;
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/, Promise.resolve(resp)];
                }
            });
        });
    };
    /**
     * 记录日志
     * @param req 日志请求
     */
    ExtEndpointModule.prototype.log = function (req) {
        // @ts-ignore
        this.logger[req.level](req.msg);
        return Promise.resolve();
    };
    // liveEvent相关
    ExtEndpointModule.prototype.liveEventOn = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            var _this = this;
            return __generator(this, function (_a) {
                adapter.registerGroupByGroupName("hyext:le_" + this.extMain.extUuid + "_" + adapter.getStreamerUid());
                event = req.event;
                this.bus.on(BusType.LIVE_EVENT, event, function (liveEvent) {
                    _this.extFrame.postMessageToBusiFrame('DEV.LiveEventMessage', liveEvent, adapter);
                });
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    ExtEndpointModule.prototype.liveEventOff = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                event = req.event;
                this.bus.off(BusType.LIVE_EVENT, event);
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    // 本地通信相关
    ExtEndpointModule.prototype.onLocalMessage = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.bus.getBus(BusType.LOCAL_MESSAGE).on(req.options.eventName, function (message) {
                    _this.extFrame.postMessageToBusiFrame(req.target, message, adapter);
                });
                return [2 /*return*/];
            });
        });
    };
    ExtEndpointModule.prototype.offLocalMessage = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.bus.getBus(BusType.LOCAL_MESSAGE).removeAllListeners(req.eventName);
                return [2 /*return*/];
            });
        });
    };
    ExtEndpointModule.prototype.postLocalMessage = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                list = adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(this.extMain.extUuid);
                list.forEach(function (m) {
                    m.bus.getBus(BusType.LOCAL_MESSAGE).emit(req.eventName, req.message);
                });
                return [2 /*return*/];
            });
        });
    };
    return ExtEndpointModule;
}(events_1.EventEmitter));
exports["default"] = ExtEndpointModule;
